function FormTransform() {
    'ngInject';

    const options = {new: {}, edit: {}};

    this.getTransform = (type, model) => options[type][model];

    this.setTransform = (type, model, fn) => options[type][model] = fn;

    this.$get = () => options;

}

angular
    .module('BB')
    .provider('FormTransform', FormTransform);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/form_transform.provider.js